import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [twofa, setTwofa] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password, twofa ? otp : undefined);
    setLoading(false);
    if (res.ok) { toast.success("Accesso effettuato"); navigate("/admin"); }
    else if (res.twofa) { setTwofa(true); toast.message("Inserisci il codice dell'app authenticator"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen bg-[#1B2A41] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-8">
          <span className="font-display text-3xl font-bold text-white">EDILSTUDIO</span>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#F5A623] font-mono mt-1">Area Riservata</div>
        </Link>
        <div className="bg-[#F7FAFC] rounded-2xl p-8 shadow-2xl">
          <div className="flex items-center gap-2 text-[#1B2A41] mb-6"><Lock className="w-5 h-5 text-[#2472C8]" /><h1 className="font-display text-2xl font-bold">Accedi al pannello</h1></div>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full px-4 py-3 rounded-xl border border-[#DCE6EF] bg-white focus:outline-none focus:ring-2 focus:ring-[#2472C8]/40" data-testid="login-email" />
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full px-4 py-3 rounded-xl border border-[#DCE6EF] bg-white focus:outline-none focus:ring-2 focus:ring-[#2472C8]/40" data-testid="login-password" />
            {twofa && <input required value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="Codice 2FA (app authenticator)" inputMode="numeric" autoFocus className="w-full px-4 py-3 rounded-xl border border-[#2472C8] bg-white focus:outline-none focus:ring-2 focus:ring-[#2472C8]/40 tracking-[0.3em] text-center" data-testid="login-otp" />}
            <button type="submit" disabled={loading} className="w-full bg-[#2472C8] hover:bg-[#1E5FA6] text-white font-semibold py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-60 transition-colors" data-testid="login-submit-btn">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : (twofa ? "Verifica codice" : "Accedi")}
            </button>
          </form>
          <Link to="/" className="block text-center text-sm text-[#566476] mt-6 hover:text-[#1B2A41]">← Torna al sito</Link>
        </div>
      </div>
    </div>
  );
}
